import { LangageIso6391, RegistrationIdType, SupplierMapping } from "@tfg/db"

import { CountryIso3166 } from "@tfg/types/endpoints/library"

interface RegistrationId {
  registrationId: string
  type: RegistrationIdType
}

export namespace ContactResponses {
  export interface Contact {
    id: string
    user: {
      id: string
      name: string
      email: string
      preferedLangageIso6391: LangageIso6391
      organization: {
        businessRelationship: SupplierMapping
        name: string
        street: string | null
        city: string | null
        postalCode: string | null
        country: CountryIso3166 | null
        registrationId: RegistrationId[]
      }
    }
  }
}

export namespace ContactRequests {
  export interface CreateContact {
    name: string
    email: string
    preferredLanguage: LangageIso6391
    organizationName: string
    organizationStreet: string | null
    organizationCity: string | null
    organizationPostalCode: string | null
    organizationCountry: string | null
    registrationId: RegistrationId[]
  }

  export interface TransferContact {
    email: string
    name: string
    language: LangageIso6391
    oldContactUserId: string
  }
}

export const CONTACT_WITH_INFORMATION_REQUESTS_ERROR =
  "CANNOT_DELETE_CONTACT_WITH_ASSIGNED_INFORMATION_REQUESTS" as const
